import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type BulkDeleteMaterialsResponse = ClientInferResponseBody<
  typeof contract.materials.bulkDeleteMaterials,
  200
>;

export const bulkDeleteMaterialsApi = async ({
  ids,
}: {
  ids: string[];
}): Promise<BulkDeleteMaterialsResponse> => {
  const response = await api.materials.bulkDeleteMaterials.mutation({
    body: { ids },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to bulk delete materials", response.status, response.body);
};
